module.exports = __webpack_public_path__ + "img/facebook-white.fc8ed536.svg";